<button ngbDropdownItem type="button" (click)="openDeleteDialog()">
  <cx-icon type="TRASH_BLUE"></cx-icon>
  {{ 'cartAdministration.cart.delete' | cxTranslate }}
</button>
